import type { StreamSettingPayload } from "./StreamSetting.types";

export const DEFAULT_STREAM_FORM: StreamSettingPayload = {
  highcourtId: "",
  benchId: "",
  benchRoomId: "",
  courtRoomId: "",
  stateId: "",
  districtId: "",
  complexId: "",
  establishmentId: "",
  delayInMinutes: "",
  links: [],
};

export const STREAM_PAGE_SIZE = 10;
